module.exports = __webpack_public_path__ + "static/media/galerija_2023 (8).fe8fc4f2.jpg";